// extracted by mini-css-extract-plugin
export default {"paymentTermsContainer":"PaymentTermsAndConditions_paymentTermsContainer__5gOTv","paperSquare":"PaymentTermsAndConditions_paperSquare__+SlN-"};